import { AppContext } from "@lightspeed-invoicing/core-client/frontend"
import $ from 'jquery'
import React, { Component } from 'react'
import { FormattedMessage, injectIntl } from 'react-intl'
import GlobalHelper from '../../common/GlobalHelper.jsx'
import ActionButton from "../../common/button/actionbutton.component.jsx"
import Checkbox from '../../common/checkbox/checkbox.component.jsx'
import DocumentUploaderDropZone from "../../common/document-uploader/dropzone.component.jsx"
import { FeatureProductExport } from '../../state/integration/IntegrationFeatureKeys'
import {IMPORT_TYPE} from "../../utils/external"

class ImportCsvModal extends Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            modalId: this.props.modalId || 'csv-import-modal',
            type: this.props.type || 'contacts',
            fileId: '',
            isAutoExportDisabled: false,
        }
        this.handleDocumentChange = this.handleDocumentChange.bind(this)
        this.closeModal = this.closeModal.bind(this)
        this.startImport = this.startImport.bind(this)
    }

    componentDidMount() {
        $('#' + this.state.modalId).modal('show')
    }

    closeModal(event) {
        event.preventDefault()
        $('#' + this.state.modalId).modal('hide')
        if (this.props.onClose) {
            this.props.onClose(event)
        }
    }

    startImport(event) {
        event.preventDefault()
        AppContext.getApiClient().post('/imports', {
            integrationKey: 'csv',
            type: this.state.type,
            fileId: this.state.fileId,
            isAutoExportDisabled: this.state.isAutoExportDisabled
        }).then(() => {
            this.closeModal(event)
        })

    }

    handleDocumentChange(documents) {
        if (documents.length > 0) {
            this.setState({
                fileId: documents[0].id,
            })
        } else {
            this.setState({
                fileId: '',
            })
        }
    }

    getTemplateUrl() {
        switch (this.state.type) {
            case IMPORT_TYPE.PRODUCTS:
                return '/files/products_template.csv'
            case IMPORT_TYPE.SUPPLIERS:
                return '/files/suppliers_template.csv'
            case IMPORT_TYPE.CONTACTS:
                return '/files/contacts_template.csv'
        }
    }

    render() {
        return (
            <div className="modal"
                id={this.state.modalId}
                role="dialog"
                aria-labelledby={this.state.modalId + "Label"}
                aria-hidden="true"
                data-backdrop="static"
                data-keyboard="false"
            >
                <div className="modal-dialog modal-signature" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <div className="modal-title h5" id={this.modalId + "Label"}>
                                <FormattedMessage
                                    id="common.csv_import.modal.title"
                                    defaultMessage="Import from csv"
                                />
                            </div>
                        </div>
                        <div className="modal-body">
                            <div className="container-fluid">
                                <div className="form-group row mb-0">
                                    <div className="col-12">
                                        <DocumentUploaderDropZone
                                            onUpdateDocumentList={this.handleDocumentChange}
                                            maxFiles={1}
                                            fileTypes={['.csv']}
                                        />
                                    </div>
                                    <div className="col-12 py-2">
                                        <a href={this.getTemplateUrl()} target={'_blank'}>
                                            <FormattedMessage
                                                id="common.csv_import.modal.download_template_link"
                                                defaultMessage="Download csv template"
                                            />
                                        </a>
                                    </div>
                                    {this.state.type === IMPORT_TYPE.PRODUCTS &&
                                        GlobalHelper.hasSupportedFeature(FeatureProductExport) &&
                                        <div className="col-12 py-2">
                                            <Checkbox className={'mr-2'} checked={this.state.isAutoExportDisabled}
                                                onChange={(isChecked) => {
                                                    this.setState({
                                                        isAutoExportDisabled: isChecked,
                                                    })
                                                }} />
                                            <FormattedMessage
                                                id="common.csv_import.modal.disable_product_auto_export"
                                                defaultMessage="Don’t auto export products from CSV import"
                                            />
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" onClick={this.closeModal}>
                                <FormattedMessage
                                    id="common.csv_import.modal.close_btn"
                                    defaultMessage="Close"
                                />
                            </button>
                            <ActionButton onClick={this.startImport} disabled={!this.state.fileId} className="btn btn-primary">
                                <FormattedMessage
                                    id="common.csv_import.modal.send_btn"
                                    defaultMessage="Start now"
                                />
                            </ActionButton>
                        </div>
                    </div>
                </div>
            </div >
        );
    }
}

export default injectIntl(ImportCsvModal)





// WEBPACK FOOTER //
// ./src/product/import/csvmodal.component.jsx